import { pianoAnalytics } from 'piano-analytics-js'
import * as CookieConsent from 'vanilla-cookieconsent'

import { isClient, isDevelopment } from 'src/lib/envSniffer'

type ClickEventOptions = {
  event_grouping: string
  item_name: string
  item_type: 'button' | 'link' | 'image' | 'video' | 'sheet'
  item_link: string
  group_name?: string
  isSignout?: boolean
}

export type Location = {
  pathname: string
  protocol: string
  hostname: string
  search: string
}

const getPathAndUrl = () => {
  let windowLocation: Location | null = null
  if (typeof window !== 'undefined') {
    windowLocation = {
      pathname: window.location.pathname,
      protocol: window.location.protocol,
      hostname: window.location.hostname,
      search: window.location.search
    }
  }

  if (windowLocation) {
    const { pathname, protocol, hostname, search } = windowLocation
    const url = `${protocol}//${hostname}${pathname}${search}`
    return { pathname, url }
  }
  return { pathname: '', url: '' }
}

export const defaultClickEvent = (clickOptions: ClickEventOptions) => {
  // comment out below to see events locally
  if (!isClient || isDevelopment || !CookieConsent || !CookieConsent.acceptedCategory('identifier'))
    return
  pianoAnalytics.sendEvent('click.action', {
    ...clickOptions
  })
}

export const pageScrollEvent = (depth: number, pageTitle?: string, previousUrl?: string | null) => {
  // comment out below to see events locally
  if (!isClient || isDevelopment || !CookieConsent || !CookieConsent.acceptedCategory('identifier'))
    return
  const { pathname, url } = getPathAndUrl()
  pianoAnalytics.sendEvent('page.scroll', {
    page: pathname.replace('/', '').replace(/\//g, '.'),
    url: url,
    page_title: pageTitle,
    referrer_url: previousUrl,
    language: 'en',
    scroll_depth: depth
  })
}
